import { render } from "./WorkflowSelections.vue?vue&type=template&id=e6b10182"
import script from "./WorkflowSelections.vue?vue&type=script&lang=js"
export * from "./WorkflowSelections.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__